export const convertTimeToMinutes = (time) => {
  if (time.includes('min')) return parseInt(time, 10);

  if (time.includes('hr')) {
    const hours = parseFloat(time, 10);
    return hours * 60;
  }

  return 0;
};

/**
 * Formats the years into a string
 * @param {number|null|undefined} years - The number of years to format
 * @returns {string} - Returns the formatted years string
 * @example
 * formatYears(5) // "5 Years"
 * formatYears(1) // "1 Year"
 * formatYears(0) // "Less than 1 Year"
 * formatYears(21) // "20+ Years"
 * formatYears(null) // ""
 * formatYears(NaN) // ""
 */
export const formatYears = (years) => {
  if (typeof years !== 'number' || Number.isNaN(years)) return '';

  if (years <= 0) return 'Less than 1 Year';
  if (years > 20) return '20+ Years';

  return `${years} Year${years > 1 ? 's' : ''}`;
};
